import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { getManageAreaListUrl, GET_MANAGE_AREA_LIST, updateManageAreaUrl, UPDATE_MANAGE_AREA, headers } from "../../../utils/constants";

export const getManageAreaList_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: JSON.parse(sessionStorage.getItem("sessionExhibitionID"))
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(getManageAreaListUrl, params, headers)

        dispatch({
            type: GET_MANAGE_AREA_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updateManageArea_action = (totalExhibitionArea, firstInstallment, secondInstallment, tempchapterList) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: JSON.parse(sessionStorage.getItem("sessionExhibitionID")),
            TotalArea: totalExhibitionArea,
            Installment1: firstInstallment,
            Installment2: secondInstallment,
            chapterList: tempchapterList,
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosPost(updateManageAreaUrl, params, headers)

        dispatch({
            type: UPDATE_MANAGE_AREA,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}